// extracted by mini-css-extract-plugin
module.exports = {"floating__nav":"floatingNavButton_floating__nav__jeyp4","float":"floatingNavButton_float__vYPhk"};